module.exports = __webpack_public_path__ + "static/media/image-campaign-donate-yen.fff3b141.png";